import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';

export const DeviceUserService = {
    getByInstitution: async (page: number = 0, size: number = 10, search?: string) => {
        const institutionId = AuthService.getSelectedInstitution();
        const params: Record<string, string | number> = { page, size };
        if (search && search.trim()) params.search = search.trim();
        const response = await axios.get(ENDPOINTS.DEVICE_USER.BY_INSTITUTION(institutionId), {
            params,
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    getUnmapped: async (page: number = 0, size: number = 10, search?: string) => {
        const institutionId = AuthService.getSelectedInstitution();
        const params: Record<string, string | number> = { page, size };
        if (search && search.trim()) params.search = search.trim();
        const response = await axios.get(ENDPOINTS.DEVICE_USER.UNMAPPED(institutionId), {
            params,
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    mapToUser: async (deviceUserId: string, userId: string) => {
        const response = await axios.put(
            ENDPOINTS.DEVICE_USER.MAP(deviceUserId),
            { userId },
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    },

    unmapUser: async (deviceUserId: string) => {
        const response = await axios.put(
            ENDPOINTS.DEVICE_USER.UNMAP(deviceUserId),
            {},
            { headers: AuthService.getAuthHeader() }
        );
        return response.data;
    }
};
